import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    annulerEntretienAnnuelRequest,
    confirmerEntretienAnnuelRequest,
    fetchEntretienAnnuelRequest,
    planifierEntretienAnnuelRequest,
    replanifierEntretienAnnuelRequest,
    terminerEntretienAnnuelRequest,
} from "../../../../redux/actions/performanceActions";
import { Field, formatDateTimeInput, StepState } from "../../Collaborateur/performanceUi";

const initialForm = { dateDebut: "", dateFin: "", lieu: "", description: "", notes: "", sendInvitation: true };

export default function EntretienManagerStep({ progressId }) {
    const dispatch = useDispatch();
    const slice = useSelector((state) => state.performance.entretienAnnuel);
    const entretien = slice.byProgressId[String(progressId)];
    const loading = slice.loadingByProgressId[String(progressId)];
    const error = slice.errorByProgressId[String(progressId)];
    const [form, setForm] = useState(initialForm);

    useEffect(() => {
        dispatch(fetchEntretienAnnuelRequest(progressId));
    }, [dispatch, progressId]);

    useEffect(() => {
        if (entretien) {
            setForm({
                dateDebut: formatDateTimeInput(entretien.dateDebut),
                dateFin: formatDateTimeInput(entretien.dateFin),
                lieu: entretien.lieu || "",
                description: entretien.description || "",
                notes: entretien.notes || "",
                sendInvitation: true,
            });
        }
    }, [entretien]);

    const update = (patch) => setForm((current) => ({ ...current, ...patch }));
    const payload = () => ({ ...form, evaluationProgressId: Number(progressId) });
    const submit = (event) => {
        event.preventDefault();
        if (entretien?.id) dispatch(replanifierEntretienAnnuelRequest(entretien.id, payload()));
        else dispatch(planifierEntretienAnnuelRequest(payload()));
    };

    return (
        <StepState loading={loading} error={error} empty={false}>
            {/* Statut actuel */}
            {entretien && (
                <div className={`perf-state perf-state--inline ${entretien.statut === "CONFIRMED" || entretien.statut === "COMPLETED" ? "perf-state--success" : ""}`}>
                    Statut : <strong>{entretien.statut || "—"}</strong>
                    {entretien.collaborateurNom && <> &nbsp;·&nbsp; {entretien.collaborateurNom}</>}
                </div>
            )}

            {/* Formulaire planification */}
            <form className="perf-item" onSubmit={submit} style={{ gap: 16 }}>
                <div className="perf-form-row">
                    <Field label="Début">
                        <input required type="datetime-local" value={form.dateDebut} onChange={(event) => update({ dateDebut: event.target.value })} />
                    </Field>
                    <Field label="Fin">
                        <input required type="datetime-local" value={form.dateFin} onChange={(event) => update({ dateFin: event.target.value })} />
                    </Field>
                    <Field label="Lieu">
                        <input value={form.lieu} onChange={(event) => update({ lieu: event.target.value })} placeholder="Salle, Teams, etc." />
                    </Field>
                </div>

                <Field label="Description">
                    <textarea value={form.description} onChange={(event) => update({ description: event.target.value })} placeholder="Description de l'entretien..." />
                </Field>
                <Field label="Notes">
                    <textarea value={form.notes} onChange={(event) => update({ notes: event.target.value })} placeholder="Notes complémentaires..." />
                </Field>

                <label className="perf-check">
                    <input type="checkbox" checked={form.sendInvitation} onChange={(event) => update({ sendInvitation: event.target.checked })} />
                    Envoyer l'invitation calendrier
                </label>

                {/* Actions */}
                <div className="perf-actions" style={{ paddingTop: 12, borderTop: "1px solid var(--perf-border)", marginTop: 4 }}>
                    <button className="perf-btn perf-btn--primary" type="submit">
                        {entretien?.id ? "Replanifier" : "Planifier"}
                    </button>
                    {entretien?.id && (
                        <button className="perf-btn" type="button" onClick={() => dispatch(confirmerEntretienAnnuelRequest(entretien.id, { evaluationProgressId: Number(progressId) }))}>
                            Confirmer
                        </button>
                    )}
                    {entretien?.id && (
                        <button className="perf-btn" type="button" onClick={() => dispatch(terminerEntretienAnnuelRequest(entretien.id, { evaluationProgressId: Number(progressId), notes: form.notes }))}>
                            Terminer
                        </button>
                    )}
                    {entretien?.id && (
                        <button className="perf-btn perf-btn--danger" type="button" onClick={() => dispatch(annulerEntretienAnnuelRequest(entretien.id, { evaluationProgressId: Number(progressId), notes: form.notes }))}>
                            Annuler l'entretien
                        </button>
                    )}
                </div>
            </form>
        </StepState>
    );
}
